import { createTheme, responsiveFontSizes } from '@mui/material/styles';

// Brand: Peak Software kobalt mavi. Birincil mavi tonu logodan,
// vurgular için sıcak amber. Light + Dark her ikisinde de marka korunur.
const palette = {
  light: {
    mode: 'light',
    primary: { main: '#1E3A8A', light: '#3B5BC9', dark: '#0F1F5C', contrastText: '#fff' },
    secondary: { main: '#F59E0B', light: '#FCC560', dark: '#B07000', contrastText: '#1A1A1A' },
    success: { main: '#16A34A' },
    warning: { main: '#F59E0B' },
    error:   { main: '#DC2626' },
    info:    { main: '#0EA5E9' },
    background: { default: '#F4F6FB', paper: '#FFFFFF' },
    text: { primary: '#0F172A', secondary: '#475569' },
    divider: 'rgba(15, 23, 42, 0.08)',
  },
  dark: {
    mode: 'dark',
    primary: { main: '#3B5BC9', light: '#6F88E8', dark: '#1E3A8A', contrastText: '#fff' },
    secondary: { main: '#FBBF24' },
    success: { main: '#22C55E' },
    warning: { main: '#F59E0B' },
    error:   { main: '#EF4444' },
    info:    { main: '#38BDF8' },
    background: { default: '#0B1220', paper: '#121A2C' },
    text: { primary: '#E2E8F0', secondary: '#94A3B8' },
    divider: 'rgba(226, 232, 240, 0.08)',
  },
};

// Tipografi — sistem sans-serif stack; iOS/Android'de yerel görünür
const typography = {
  fontFamily: [
    '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto',
    '"Helvetica Neue"', 'Arial', 'sans-serif',
    '"Apple Color Emoji"', '"Segoe UI Emoji"',
  ].join(','),
  h1: { fontWeight: 700, fontSize: '2.25rem', letterSpacing: '-0.02em' },
  h2: { fontWeight: 700, fontSize: '1.75rem', letterSpacing: '-0.015em' },
  h3: { fontWeight: 700, fontSize: '1.5rem' },
  h4: { fontWeight: 700, fontSize: '1.25rem' },
  h5: { fontWeight: 600, fontSize: '1.125rem' },
  h6: { fontWeight: 600, fontSize: '1rem' },
  button: { textTransform: 'none', fontWeight: 600 },
};

// Component varsayılanları — yumuşak köşeler, hafif gölge, butonlarda
// caps yok (textTransform), tablolarda kompakt görünüm
const components = {
  MuiCssBaseline: {
    styleOverrides: {
      body: { WebkitFontSmoothing: 'antialiased', MozOsxFontSmoothing: 'grayscale' },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: { backgroundImage: 'none' },
    },
  },
  MuiAppBar: {
    defaultProps: { elevation: 0 },
    styleOverrides: {
      root: ({ theme }) => ({
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
      }),
    },
  },
  MuiButton: {
    defaultProps: { disableElevation: true },
    styleOverrides: {
      root: { borderRadius: 10 },
    },
  },
  MuiCard: {
    defaultProps: { elevation: 0 },
    styleOverrides: {
      root: ({ theme }) => ({
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 14,
      }),
    },
  },
  MuiTableHead: {
    styleOverrides: {
      root: ({ theme }) => ({
        backgroundColor: theme.palette.mode === 'light' ? '#F8FAFC' : '#0F172A',
      }),
    },
  },
  MuiTableCell: {
    styleOverrides: {
      head: { fontWeight: 700, color: 'inherit' },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: ({ theme }) => ({
        borderRight: `1px solid ${theme.palette.divider}`,
      }),
    },
  },
  MuiChip: {
    styleOverrides: {
      root: { fontWeight: 600 },
    },
  },
};

const shape = { borderRadius: 12 };

export function buildTheme(mode = 'light') {
  let t = createTheme({
    palette: palette[mode] || palette.light,
    typography,
    shape,
    components,
  });
  t = responsiveFontSizes(t);
  return t;
}

export default buildTheme;
